export default __webpack_public_path__ + "static/media/social2.89351cd8.svg";